<template>
  <div>
    <div v-if="studentReport">
      <img
        src="/static/logos/static_student_report.png"
        class="absolute"
        style="
          top: 52px;
          left: 57px;
          height: calc(100% - 52px);
          width: calc(100% - 57px);
          z-index: 10;
        "
      />
    </div>
    <pl-dialog :size="'md'" :disableOutsideClick="true">
      <header class="text-gray-700 flex justify-end items-center px-5 py-4">
        <button
          @click="$emit('close')"
          class="w-7 h-7 focus:ring-2 focus:ring-offset-2 focus:ring-primary-dark rounded-full cursor-pointer hover:bg-gray-100 text-lg flex items-center justify-center hover:text-primary text-blueGray-700"
        >
          <i class="fas fa-times"></i>
        </button>
      </header>
      <body class="px-7 pb-10 flex flex-col flex-grow justify-center items-center overflow-y-auto">
        <img src="/static/waffle_icons/unlock.svg" class="w-14 mb-8" />
        <div class="text-2xl font-bold font-manrope">
          You've discovered a premium feature!
        </div>
        <div class="mb-8 flex flex-col text-base font-normal">
          <div class="flex justify-center font-manrope">
            Upgrading your Parlay account will unlock the {{ text }}
          </div>
        </div>
        <div class="flex flex-col">
          <button class="mb-2.5 px-8 py-2 bg-primary rounded cursor-pointer text-white font-manrope hover:bg-primary-dark" @click="upgrade">
            Upgrade Now
          </button>
          <button class="px-8 py-2 bg-gray-100 hover:bg-gray-200 rounded cursor-pointer text-gray-500 font-manrope" @click="$emit('close')">
            Maybe Later
          </button>
        </div>
      </body>
    </pl-dialog>
  </div>
</template>
<script>
  export default {
    props: {
      text: {
        type: String,
        default() {
          return '';
        },
      },
      studentReport: {
        type: Boolean,
        default() {
          return false;
        },
      },
    },
    methods: {
      upgrade() {
        this.$emit('close');
        this.$router.push({
          name: 'profile.membership',
        });
      },
    },
  };
</script>



// WEBPACK FOOTER //
// upgradeModal.vue?b0c05ed4